import React from 'react';
import styles from './IndexAccessErrorModal.module.css'; 

interface Props {
    onClose: () => void;
    indexNames: string[];
}

export const IndexAccessErrorModal: React.FC<Props> = ({ onClose, indexNames }) => {
  return (
    <div className={styles.modal}>
      <div className={styles['modal-content']}>
        {indexNames.map((name) => (
          <p key={name} className={styles.errorMessage}>
            インデックス "{name}" へのアクセス権がありません
          </p>
        ))}
        <button onClick={onClose} className={`${styles.closeButton} ${styles.blackBackground}`}>閉じる</button>
      </div>
    </div>
  );
};
